import { Grid, Typography, useTheme } from "@mui/material";
import { Circle } from "@mui/icons-material";
import { OrderStatus, getOrderStatusColor, getOrderStatusText } from "../models/enums/OrderStatus";

interface OrderStatusBadgeProps {
    status: OrderStatus;
    size?: 'small' | 'medium';
}

export const OrderStatusBadge = ({ status }: OrderStatusBadgeProps) => {
    const theme = useTheme();

    const getStatusStyleBorder = (status: OrderStatus) => ({
        backgroundColor: getOrderStatusColor(status, theme),
        borderRadius: 6,
        padding: 8,
        paddingX: 12,
        display: "inline-block",
    });

    return (
        <Grid
            item
            style={getStatusStyleBorder(status)}
            marginY={2}
        >
            <Typography
                variant={"body2"}
                padding={1}
                paddingX={2}
                style={{ color: theme.palette.common.white, fontWeight: "bold" }}
            >
                {getOrderStatusText(status)}
            </Typography>
        </Grid>
    );
};

export const OrderStatusBadgeCompact = ({ status, size = 'medium' }: OrderStatusBadgeProps) => {
    const theme = useTheme();
    const isSmall = size === 'small';

    return (
        <Grid
            item
            style={{ display: "flex", alignItems: "center", gap: isSmall ? 4 : 6 }}
        >
            <Circle
                sx={{
                    color: getOrderStatusColor(status, theme),
                    fontSize: isSmall ? 8 : 12,
                }}
            />
            <Typography
                variant={"caption"}
                style={{ 
                    color: theme.customColors.textPrimary,
                    fontSize: isSmall ? 10 : 12
                }}
            >
                {getOrderStatusText(status, true)}
            </Typography>
        </Grid>
    );
};